import { render, staticRenderFns } from "./ButtonGallery.vue?vue&type=template&id=77d0f444&scoped=true"
import script from "./ButtonGallery.vue?vue&type=script&lang=ts"
export * from "./ButtonGallery.vue?vue&type=script&lang=ts"
import style0 from "./ButtonGallery.vue?vue&type=style&index=0&id=77d0f444&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d0f444",
  null
  
)

export default component.exports